import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductIdv20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M2.75 2.75H6.57143V1.25H2.57143C1.84162 1.25 1.25 1.84162 1.25 2.57143V6.57143H2.75V2.75Z'
      fill='currentColor'
    />
    <path
      d='M17.25 2.75H13.4286V1.25H17.4286C18.1584 1.25 18.75 1.84162 18.75 2.57143V6.57143H17.25V2.75Z'
      fill='currentColor'
    />
    <path
      d='M2.75 17.25V13.4286H1.25V17.4286C1.25 18.1584 1.84162 18.75 2.57143 18.75H6.57143V17.25H2.75Z'
      fill='currentColor'
    />
    <path
      d='M17.25 17.25V13.4286H18.75V17.4286C18.75 18.1584 18.1584 18.75 17.4286 18.75H13.4286V17.25H17.25Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.05546 6.05546C8.57118 5.53973 9.27065 5.25 10 5.25C10.7293 5.25 11.4288 5.53973 11.9445 6.05546C12.4603 6.57118 12.75 7.27065 12.75 8C12.75 8.88719 12.3056 9.74093 11.5812 10.25H12C13.5188 10.25 14.75 11.4812 14.75 13V14H13.25V13C13.25 12.3096 12.6904 11.75 12 11.75H8C7.30964 11.75 6.75 12.3096 6.75 13V14H5.25V13C5.25 11.4812 6.48122 10.25 8 10.25H8.41884C7.69442 9.74092 7.25 8.88719 7.25 8C7.25 7.27065 7.53973 6.57118 8.05546 6.05546ZM10 6.75C9.31917 6.75 8.75 7.31917 8.75 8C8.75 8.68083 9.31917 9.25 10 9.25C10.6808 9.25 11.25 8.68083 11.25 8C11.25 7.31917 10.6808 6.75 10 6.75Z'
      fill='currentColor'
    />
  </Svg>
);

ProductIdv20.displayName = 'ProductIdv20';
export default ProductIdv20;
